import styled from 'styled-components'

export const PDFWrapper = styled.div`
  height: 100%;
  #PDFWrapper-Object {
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    iframe {
      width: 100%;
    }
    ${props => props.theme.breakpoints.down('xs')} {
      display: none;
    }
  }
  .PDFPage__Mobile {
    display: none;
    text-align: center;
    padding: 0 16px;
    box-sizing: border-box;
    ${props => props.theme.breakpoints.down('xs')} {
      display: block;
    }
  }
`
